import axios from "axios";
import config from "../../config/config";
import * as mocks from "./packages.mocks";
import * as api from "./packages.api";
import { PurchasedPackage, AvailablePackage, PackageModuleInfo } from "./packages.interfaces";

export const getPurchasedPackages = async (): Promise<PurchasedPackage[]> => {
  if (config.useRealApi) {
    return await api.apiGetPurchasedPackages();
  }

  if (config.useMockServer) {
    const { data } = await axios.get<PurchasedPackage[]>(`${config.mockBaseUrl}/student/packages/purchased`);
    return data;
  }

  return await mocks.getPurchasedPackages();
};

export const getAvailablePackages = async (): Promise<AvailablePackage[]> => {
  if (config.useRealApi) {
    return await api.apiGetAvailablePackages();
  }

  if (config.useMockServer) {
    const { data } = await axios.get<AvailablePackage[]>(`${config.mockBaseUrl}/student/packages/available`);
    return data;
  }

  return await mocks.getAvailablePackages();
};

// Nova função para obter os módulos de um pacote específico
export const getPackageModules = async (packageId: string): Promise<PackageModuleInfo[]> => {
  if (config.useRealApi) {
    return await api.apiGetPackageModules(packageId);
  }

  if (config.useMockServer) {
    const { data } = await axios.get<PackageModuleInfo[]>(`${config.mockBaseUrl}/student/packages/modules`, {
      params: { packageId }
    });
    // Se o json-server retornar um wrapper { packageId, modules }, extrair
    if (Array.isArray(data) && data.length && (data[0] as any).modules) {
      return (data[0] as any).modules as PackageModuleInfo[];
    }
    return data;
  }

  return await mocks.getPackageModules(packageId);
};

/**
 * Verifica se o estudante tem pacotes comprados
 * @returns true se o estudante tem pelo menos um pacote comprado, false caso contrário
 */
export const hasPurchasedPackages = async (): Promise<boolean> => {
  try {
    const packages = await getPurchasedPackages();
    return packages.length > 0;
  } catch (error) {
    console.error("Error checking purchased packages:", error);
    // Em caso de erro, assumir que não tem pacotes para evitar bloqueio
    return false;
  }
};